export interface PasswordValidation {
  isValid: boolean;
  strength: "weak" | "medium" | "strong";
  rules: {
    minLength: boolean;
    hasUppercase: boolean;
    hasNumber: boolean;
  };
}

export function validatePassword(password: string): PasswordValidation {
  const rules = {
    minLength: password.length >= 8,
    hasUppercase: /[A-Z]/.test(password),
    hasNumber: /[0-9]/.test(password),
  };

  const passedRules = Object.values(rules).filter(Boolean).length;

  return {
    isValid: passedRules === 3,
    strength: passedRules <= 1 ? "weak" : passedRules === 2 ? "medium" : "strong",
    rules,
  };
}
